import { Box, Skeleton, Card } from '@mui/material';

export default function ConfigureIntegrationFormSkeleton() {
  return (
    <Box>
      {/* header */}
      <Box display='flex' alignItems='center' gap={1} mb={2}>
        <Skeleton variant='circular' width={36} height={36} />
        <Skeleton variant='text' width={220} height={32} />
      </Box>

      {/* banner */}
      <Card
        sx={{
          borderRadius: '8px',
          p: '16px',
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          mb: 3,
          boxShadow: 'none'
        }}
      >
        <Skeleton variant='rounded' width={40} height={40} />
        <Box width='100%'>
          <Skeleton variant='text' width='30%' height={22} />
          <Skeleton variant='text' width='70%' height={18} />
        </Box>
      </Card>

      {/* segmented tabs */}
      <Box
        sx={{
          display: 'flex',
          backgroundColor: '#fff',
          borderRadius: 2,
          p: '6px',
          mb: 3,
          gap: 1
        }}
      >
        <Skeleton variant='rounded' height={42} sx={{ flex: 1 }} />
        <Skeleton variant='rounded' height={42} sx={{ flex: 1 }} />
      </Box>

      {/* form card */}
      <Box bgcolor='#fff' padding={2} borderRadius={2}>
        {/* section title */}
        <Skeleton variant='text' width={180} height={26} />
        <Skeleton variant='text' width={320} height={18} sx={{ mb: 2 }} />

        {/* inputs */}
        <Skeleton variant='rounded' height={56} sx={{ mb: 2 }} />
        <Skeleton variant='rounded' height={56} sx={{ mb: 2 }} />
        <Skeleton variant='rounded' height={56} sx={{ mb: 2 }} />
        <Skeleton variant='rounded' height={56} sx={{ mb: 2 }} />

        {/* button */}
        <Box display='flex' justifyContent='flex-end' mt={3}>
          <Skeleton variant='rounded' width={120} height={40} />
        </Box>
      </Box>
    </Box>
  );
}
